export { VerifyEmail as default } from './VerifyEmail';
